export enum DirDataTypeEnum {
    None = 0,
    ClinicalDocuments = 1,
    ParticipantData = 2,
    SummaryData = 3,
}
